import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import period from './period'
import homepage from './homepage'
import records from './records'
import deliveryAddress from './delivery-address'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // 在非生产环境下，使用严格模式
  modules: {
    user,
    period,
    homepage,
    records,
    deliveryAddress
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js